'use client';
const getSlideTransition = (position)=>{
    if (position == null ? void 0 : position.startsWith('top')) {
        return 'slide-down';
    }
    if (position == null ? void 0 : position.startsWith('right')) {
        return 'slide-left';
    }
    if (position == null ? void 0 : position.startsWith('bottom')) {
        return 'slide-up';
    }
    if (position == null ? void 0 : position.startsWith('left')) {
        return 'slide-right';
    }
    return undefined;
};

export { getSlideTransition };
//# sourceMappingURL=transition.js.map
